import React from 'react'
import Manager from 'tyan/public/components/Manager'
import AssetChangeDiv from './AssetChangeDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '资产异动编号', field: 'Number', minWidth: 150, flex: 1, search: true },
        { _text: '移出部门', field: 'MoveOutDep', minWidth: 200, flex: 1, search: true },
        { _text: '异动原因', field: 'Changecc', minWidth: 150, flex: 1 },
        { _text: '资产性质', field: 'AssetNature', minWidth: 100, flex: 1, filter: true },
        { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
        { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
        { _: 'taskName', field: 'Task.TaskName' }
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <AssetChangeDiv {...props} id={data.id} taskName={data.taskName} />)
    }
}

export default props => <Manager {...props} config={config} />